export default "__VITE_ASSET__4Osslw3A__"